// var chains = '<div class="swatch-size custom-select-wrapper chain-selector d-none d-lg-block"><select class="custom-select"><option data-prodid="0" data-original-price="0" data-price="0">No Chain</option>';



(function ($) {

  'use strict';

  var store = 'aime-leon-dore';
  if(window.location.host.indexOf('eu') > -1) {
    store = 'aime-leon-dore-eu';
  }
  if(window.location.host.indexOf('dev') > -1) {
    store = 'aime-leon-dore-dev-store';
  }
  if(window.location.host.indexOf('eu-dev') > -1) {
    store = 'aime-leon-dore-eu-dev';
  }

  function getShipDelayFromSelect($select) {
    if(!$select || !$select.length) return null;
    const $opt = $select.find(':selected');
    const delayFlag = $opt.data('ship-delay');
    const shipDelayMessage = $opt.data('ship-delay-message');
    const hasDelay = (delayFlag === true || delayFlag === 'true') && !$opt.hasClass('disabled-el');
    if(hasDelay) {
      return shipDelayMessage || ''
    }
    return null;
  }

  const setNavCartCount = (count) => {
    count = parseInt(count, 10);
    if(isNaN(count) || count < 0) {
      count = 0;
    }

    $('.cart-count').text(count);

    if(count > 0) {
      $('.cart-ic').addClass('active-cart');
      $('.navbar').addClass('navbar--active-cart');
    } else {
      $('.cart-ic').removeClass('active-cart');
      $('.navbar').removeClass('navbar--active-cart');
    }
  };

  window.syncCartCount = () => {
    const cartUrl = `/cart.js?_=${Date.now()}`;

    return fetch(cartUrl, {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then((response) => response.json())
      .then((cart) => {
        setNavCartCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
        return cart;
      })
      .catch(() => null);
  };

  const shouldSyncCartOnPageShow = (event) => {
    if(event && event.persisted) {
      return true;
    }

    if(window.performance && typeof window.performance.getEntriesByType === 'function') {
      const [navigationEntry] = window.performance.getEntriesByType('navigation');
      if(navigationEntry && navigationEntry.type === 'back_forward') {
        return true;
      }
    }

    return false;
  };

  window.addEventListener('pageshow', (event) => {
    if(!document.querySelector('.cart-count')) {
      return;
    }

    const shouldSync = shouldSyncCartOnPageShow(event);

    if(shouldSync) {
      window.syncCartCount();
    }
  });

  var aldscripts = {
    init: function () {
      // separate loads for product and cart page
      if(location.pathname.includes('/products/')) {
        aldscripts.recentlyViewed();  
      }
      // separate loads for product and cart page
      if(location.pathname.includes('/cart') || location.pathname.includes('/products/')) {
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        // if(isSafari || getOS() == 'Mac OS') {
        if(window.innerWidth > 1024) {
          var height = window.innerHeight;
          var imgHeight = height - 340;
          var width = Math.floor((4 * imgHeight) / 5);
          $('.upsell-carousel, .cart-upsell').width(width);
          if(width > 493) {
            $('.upsell-carousel img').width('100%');
          }
        }
        // }


        $(window).on('resize', function() {
          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          // if(isSafari || getOS() == 'Mac OS') {
          if(window.innerWidth > 1024) {
            var height = window.innerHeight;
            var imgHeight = height - 340;
            var width = Math.floor((4 * imgHeight) / 5);
            $('.upsell-carousel, .cart-upsell').width(width);
            if(width > 493) {
              $('.upsell-carousel img').width('100%');
            } else {
              $('.upsell-carousel img').width('');
            }
          } else {
            $('.upsell-carousel, .cart-upsell').width('');
          }
          // }
        })

        aldscripts.loadUpsell();

        const closeUpsellQuickview = () => {
          $('.cart-upsell-collapse').removeClass('cart-upsell-collapse');
          $('.cart-upsell-overlay').removeClass('cart-upsell-overlay--visible');
          $('.cart-upsell-container').removeClass('cart-upsell-container--visible');
          $('body').removeClass('cart-upsell--visible');
        };

        const refreshUpsellCartCount = () => {
          window.syncCartCount();
        };

        const fetchCartSection = () => {
          const url = '/cart?sections=cart-template';
          return fetch(url, { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(json) { return json['cart-template'] || ''; });
        };

        const refreshCartPageSection = () => {
          if(window.location.pathname.indexOf('/cart') === -1) {
            return;
          }

          fetchCartSection()
            .then(function(sectionHtml) {
              if(!sectionHtml) {
                return;
              }

              const parser = new DOMParser();
              const responseDoc = parser.parseFromString(sectionHtml, 'text/html');
              const updatedCartSection = responseDoc.querySelector('#shopify-section-cart-template .section.section-cart') || responseDoc.querySelector('.section.section-cart');
              const currentCartSection = document.querySelector('#shopify-section-cart-template .section.section-cart') || document.querySelector('.cart--page .section.section-cart') || document.querySelector('#shopify-section-cart-template .section.cart-empty') || document.querySelector('.section.cart-empty');

              if(updatedCartSection && currentCartSection) {
                currentCartSection.outerHTML = updatedCartSection.outerHTML;
              }
            })
            .catch(function() {});
        };

        const finalizeUpsellAdd = () => {
          closeUpsellQuickview();
          refreshUpsellCartCount();
          refreshCartPageSection();
        };


        $('.cart-upsell-container').on('click', '.btn-upsell-add:not(.btn-upsell-add--stl)', function() {
          if($(this).closest('.cart-upsell').find('.chain-select').length) {

            var variantId = $(this).closest('.cart-upsell').data('variantid');
            var productId = $(this).closest('.cart-upsell').data('productid');
            var qty = 1;

            // const indexOfYAMLProduct = $('.you-may-also-like-products').find(`#upsellymal-${productId}`).index();
            const isProductPage = window.location.href.indexOf('/products/') > -1
            const isYMAL = $(this).hasClass('btn-upsell-add--ymal');
            const recentlyViewedProperty = isProductPage ? { _recently_viewed_product_pdp: "true" } : { _recently_viewed_product: "true" }
            
            var indexOfYAMLProduct = 'TI';
            

            

            

            const ymalProperty = isProductPage ? { _ymal_product_pdp: indexOfYAMLProduct } : { _ymal_product: indexOfYAMLProduct };
            const properties = isYMAL ? ymalProperty : recentlyViewedProperty;

            var chainData = {
              quantity: 1,
              id: variantId,
              properties
            }

            // add pendant
            $.ajax({
              url: '/cart/add',
              type: 'POST',
              dataType: 'json',
              data: chainData,
              success: function(response) {

                var normalizeJewelryAttr = function(value) {
                  if (!value) {
                    return '';
                  }
                  return String(value)
                    .split('//')
                    .filter(function(entry) { return entry && entry.trim() !== ''; })
                    .join('//');
                };

                var baseAttr = normalizeJewelryAttr(jewelryAtrributes);
                var pairValue = variantId + '::' + chainId;
                var updatedAttr = baseAttr ? (baseAttr + '//' + pairValue) : pairValue;

                if(chainId != 0) {

                  var chainData = {
                    quantity: 1,
                    id: chainId,
                    // note: $('#product-form-id').val() + '::' + chainId,
                    attributes: {
                      'jewelry': updatedAttr
                    },
                    properties: {
                      _recently_viewed_product: "true"
                    }
                  }

                  $.ajax({
                    url: '/cart/add',
                    type: 'POST',
                    dataType: 'json',
                    data: chainData,
                    success: function(response) {

                      jewelryAtrributes = updatedAttr;
                      finalizeUpsellAdd();

                    },
                    error: function(data){
                      alert('No more units available.');
                    }
                  });

                } else {

                  $.ajax({
                    url: '/cart/update.js',
                    data: 'attributes[jewelry]=' + updatedAttr,
                    method: 'POST',
                    async: false,
                    dataType: 'json',
                    cache: false,
                    success: function() {
                      jewelryAtrributes = updatedAttr;
                      finalizeUpsellAdd();
                    }
                  });

                }

              }
            });

          } else {
            // var variantId = $(this).closest('.upsell-form').find('.swatch-size')[1].find('select').val();
            var variantId = $(this).closest('.upsell-form').find('.swatch-size4 select').val();;
            var qty = 1;

        var anySelectedVariant = '';

        // new template
        if($(this).closest('.upsell-form').find('.swatch-size select').length) {
          anySelectedVariant = $(this).closest('.upsell-form').find('.swatch-size select').val() == '' ? false : true;

          if(!anySelectedVariant) {
            $(this).closest('.upsell-form').find('.swatch-size').addClass('select-error');
          } else {
            $(this).closest('.upsell-form').find('.swatch-size').removeClass('select-error');
            // const shipDelayValue = getShipDelayFromSelect($(this).closest('.upsell-form').find('.swatch-size4 select'));
            // var chainData = {
            //   quantity: 1,
            //   id: variantId,
            //   properties: {
            //     _recently_viewed_product: "true"
            //   }
            // }
            // if(shipDelayValue) {
            //   chainData.properties['_ship_delay'] = shipDelayValue;
            // }

            var productPrimaryData = $(this).closest('.cart-upsell');
            var limited = productPrimaryData.data('limited');
            var limitedValue = productPrimaryData.data('limit-val');
            var productId = productPrimaryData.data('productid');

            // const indexOfYAMLProduct = $('.you-may-also-like-products').find(`#upsellymal-${productId}`).index();
            const isProductPage = window.location.href.indexOf('/products/') > -1
            const isYMAL = $(this).hasClass('btn-upsell-add--ymal');
            const recentlyViewedProperty = isProductPage ? { _recently_viewed_product_pdp: "true" } : { _recently_viewed_product: "true" }
            
            var indexOfYAMLProduct = 'TI';
            

            

            

            const ymalProperty = isProductPage ? { _ymal_product_pdp: indexOfYAMLProduct } : { _ymal_product: indexOfYAMLProduct };
            const properties = isYMAL ? ymalProperty : recentlyViewedProperty;

            var chainData = {
              quantity: 1,
              id: variantId,
              properties,
            }

            const shipDelayValue = getShipDelayFromSelect($(this).closest('.upsell-form').find('.swatch-size4 select'));
            if(shipDelayValue) {
              chainData.properties['_ship_delay'] = shipDelayValue;
            }

            console.log('qty-limit', limited, limitedValue);

            if(raffleCount && raffleCount > 0) {
              $('.raffle-overlay, .raffle-mismatch-regular').show();
              return;
            }

            if(limited) {

var totalSum = 0;
$.getJSON('/cart.js', function(cart) {
  var lineitems = cart.items;
  for(var i in lineitems) {
    if(lineitems[i].product_id == productId) {
      totalSum = totalSum + lineitems[i].quantity;
    }
  }
  if(totalSum < limitedValue) {
    console.log('qty-limit perform ajax')
              $.ajax({
                url: '/cart/add',
                type: 'POST',
                dataType: 'json',
                data: chainData,
                success: function(response) {
                  finalizeUpsellAdd();
                }
              });
  } else {
    alert('You have reached maximum quantity for this product per customer.')
  }
});


            } else {

              $.ajax({
                url: '/cart/add',
                type: 'POST',
                dataType: 'json',
                data: chainData,
                success: function(response) {
                  finalizeUpsellAdd();
                }
              });

            }
          }
        }


          }



          return false;
        });

            $('#notify_email').on('focus', function() {
      if($(window).width() < 1025) {
        if($('#notify_email').val() == 'enter a valid email address') {
          $('#notify_email').attr('placeholder', '')
          $('#notify_email').val('')
        }
      }
    });
      }
    },

    recentlyViewed: function() {
      var storedProductsMax = 8;
      var storedProductsArray = [];
      var currentProductId = $('#prodid').val();

      if(localStorage.getItem('recentlyViewed') === null) {
        localStorage.setItem('recentlyViewed', '');
      } else {
        storedProductsArray = localStorage.getItem('recentlyViewed').split(',');
      }

      // check if prod id exists on a page
      // check if prod id exists already in the array
      storedProductsArray.unshift(currentProductId);

      // remove if more than max
      storedProductsArray = storedProductsArray.join();
      localStorage.setItem('recentlyViewed', storedProductsArray);
    },

    loadUpsell: function() {
if($('.raffle-product').length == 0) {

      var productIds = localStorage.getItem('recentlyViewed').split(',').map(Number);
      productIds = productIds.filter(function(item, pos, self) {
        return self.indexOf(item) == pos;
      });
      // clean up - remove products existing on the cart
      var cartProductIds = [];
      $('form.cart .cart-item').each(function() {
        cartProductIds.push($(this).data('productid'));
      });
      productIds = productIds.filter(function(el) {
        return cartProductIds.indexOf(el) < 0;
      })

      if($('body').hasClass('template-product')) {
        console.log('product_info 3 pre 1', productIds)
        var currentProductIdLoaded = parseInt($('#prodid').val());
        console.log('product_info 3 pre 3', productIds.indexOf(currentProductIdLoaded))
        productIds = productIds.filter(function(item) {
          console.log('product_info inside', item, currentProductIdLoaded)
          return item !== currentProductIdLoaded
        })

        console.log('product_info 3 pre 4', productIds)

        var currentProductIds = $('.cart-ic').data('productids');
        if(currentProductIds !== undefined) {
          currentProductIds = currentProductIds.slice(0, -1);
          var cartProductIds = currentProductIds.split(',').map(Number);
          productIds = productIds.filter(function(el) {
            return cartProductIds.indexOf(parseInt(el)) < 0;
          })
        }

        // if(productIds.indexOf(currentProductIdLoaded) > -1) {
        //   console.log('product_info 3 pre 2')
        //   productIds = productIds.splice(productIds.indexOf(currentProductIdLoaded), 1);
        // }
      }

      var dataToSend = {
        'store_name': store,
        'product_ids': productIds,
        'iso_code': Shopify.country,
        // 'location_id': 68178706569
        // 'location_ids': [35407921289, 68178706569]
      }

      if(window.location.host.indexOf('eu') > -1) {
        var locationId = 50003247253;
        if($('body').attr('data-country') == 'GB') {
          locationId = 74146152597;
        }

        var dataToSend = {
          'store_name': store,
          'product_ids': productIds,
          'iso_code': Shopify.country,
          'location_ids': [locationId]
        }
      }

    if(productIds.length > 0) {
      $.ajax({
        url: 'https://ald-filter-staging.herokuapp.com/api/product_info',
        type: 'POST',
        data: JSON.stringify(dataToSend),
        accept: 'application/json',
        cache: false,
        dataType: 'json',
        contentType: 'application/json',
        success: function(response) {
          var counter = 1;
          for(var i in response) {
            if(response[i].product_id !== undefined) {
              if(counter < 9) {
                if(response[i].sold_out != true && response[i].tags.indexOf('RAFFLE_PRODUCT') < 0 && response[i].tags.indexOf('dev-in-store-only') < 0) {
                  // if(response[i].tags.indexOf('a_ss25_drop1') > -1) {

                  var product = response[i];
                  // TODO should be local_price
                  var price = formatPrice(response[i].local_price.price, response[i].local_price.currency);
                  // var price = formatPrice(response[i].price, 'USD');
                  var compareAtPrice = price;

                  if(response[i].local_price.compare_at_price !== null) {
                    compareAtPrice = response[i].local_price.compare_at_price;
                  } else {
                    compareAtPrice = 0;
                  }
                  var priceToDisplay = '';
                  var classCompare = '';

                  priceToDisplay += '<span class="money">'+price+'</span>';
                  if(response[i].local_price.price < compareAtPrice && response[i].local_price.compare_at_price != 0) {
                    compareAtPrice = formatPrice(response[i].local_price.compare_at_price, response[i].local_price.currency);
                    priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                    classCompare = 'plp-product__price--compare';
                  }

                  var images = '';
                  for(var j in response[i].images) {
                    if(j != 0) {
                      if(response[i].images[j].alt != 'dev-product-image-swatch') {
                        images += `                    <div class="swiper-slide upsell-carousel__item">
                          <img src="${response[i].images[j].url}&width=600" alt="" />
                        </div>`
                      }
                    }
                  }
                  var sizes = '<select class="custom-select" name="sizes-'+product.product_id+'">';

                  var swatchesMobile = '<option value="">Select Color</option>';
                  var swatches = '';
                  var swatchesIds = '';

                  for(var z in response[i].handles_info) {

                    var swatchData = response[i].handles_info[z];
                    var swatchHandle = Object.keys(swatchData);
                    var swatchId = Object.values(swatchData);
                    swatchesIds += Object.values(swatchData) + ',';

                    if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                      swatchesIds = jewelrySwatchIds;
                    }

                    var selected = '';
                    var selectedClass = '';
                    if(response[i].product_id == swatchId) {
                      selected = 'selected';
                      selectedClass = 'swatch-colors__item--selected';
                    }

                    swatches += `<a href="/products/${swatchHandle}" class="swiper-slide ${selectedClass} swatch-colors__item upsell-toggle" id="${product.product_id}" new="" data-swatchid="${swatchId}" data-swatchids="${swatchesIds}">
                              <div class="image-square product-image">
                              </div>
                            </a>`

                    var colors = response[i].handles[0];
                    colors = Object.values(colors);
                    colors = colors[0];

                    if(typeof colors === 'string') {
                      colors = colors.replace(/\([^)]*\)/g, '').split(',').map(function(entry) {
                        return entry.trim();
                      }).filter(function(entry) {
                        return entry !== '';
                      });
                    }

                    colors = colors[z];
                    swatchesMobile += `<option ${selected} data-img="" data-handle="" data-swatchid="${swatchId}">${colors}</option>`
                  }

                  if(response[i].handles_info == null) {
                    swatchesMobile = `<option selected data-img="${response[i].image_url}&width=100" data-handle="" data-swatchid="">${response[i].variants[0].color}</option>`;
                  }

                  swatchesIds = swatchesIds.slice(0, -1);

/*

*/
                  const shipDelaySku = response[i].metafields?.find(mf => mf.ship_delay_skus)?.ship_delay_skus || '';
                  const shipDelayMessage = response[i].metafields?.find(mf => mf.ship_delay_message)?.ship_delay_message || '';

                  if(response[i].variants.length == 1) {
                    sizes += '<option value=""></option>';
                    const singleHasDelay = shipDelaySku.indexOf(response[i].variants[0].sku) > -1 && !response[i].variants[0].sold_out;
                    const singleDelayAttr = ` data-ship-delay="${singleHasDelay}" data-ship-delay-message="${shipDelayMessage}"`;
                    if(response[i].variants[0].sold_out) {
                      sizes += `<option class="disabled-el" data-soldout="${response[i].variants[0].sold_out}"${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                    } else {
                      sizes += `<option data-soldout="${response[i].variants[0].sold_out}" selected${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                    }
                  } else {
                    for(var k in response[i].variants) {
                      sizes += '<option value=""></option>';
                      const variantHasDelay = shipDelaySku.indexOf(response[i].variants[k].sku) > -1 && !response[i].variants[k].sold_out;
                      const delayAttr = ` data-ship-delay="${variantHasDelay}" data-ship-delay-message="${shipDelayMessage}"`;
                      if(response[i].variants[k].sold_out) {
                        sizes += `<option class="disabled-el" data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                      } else {
                        sizes += `<option data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                      }
                    }
                  }

                  sizes += '</select>';

                  var sizesMobile = '';
                  var showSelectOptions = 'd-none';
                  var showAddToCart = '';
                  var jewelryClass = '';
                  if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                    jewelryClass = 'chain-selector';
                    showSelectOptions = 'd-block';
                    showAddToCart = 'd-none d-lg-block';
                    sizes = $('.chain-select')[0].outerHTML;
                    // sizes = '<select class="custom-select" disabled><option>One Size</option></select>'

                    swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                    swatchesMobile = $('.pendant-select')[0].innerHTML;
                  }

                  var colorName = response[i].variants[0].color;
                  var customTag = '';

                  if(response[i].tags.indexOf('PREORDER_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">Reserve</div>';
                  }
                  if(response[i].tags.indexOf('NEW_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">NEW</div>  ';
                  }
                  if(response[i].tags.indexOf('dev-product-type-women') > -1) {
                    customTag = '<div class="plp-product__tag plp-product__tag--nocaps">Women\'s</div>  ';
                  }

                  var productLimited = false;
                  var productQuantityLimitNumber = 0;
                  if(response[i].tags.indexOf('dev-qty-limit') > -1) {
                    productLimited = true;
                    productQuantityLimitNumber = response[i].tags.substring(response[i].tags.indexOf('dev-qty-limit')+14, response[i].tags.indexOf('dev-qty-limit')+15);
                  }

                  $('.recently-viewed').show();

                  if(product.tags.indexOf('dev-non-us-oos') > -1) {
                    if(Shopify.country !== 'US') {
                      for(const i in product.metafields) {
                        if(product.metafields[i]['non_us_oos_label'] !== undefined) {
                          priceToDisplay = product.metafields[i]['non_us_oos_label']
                        }
                      }
                    }
                  }



                  $('.recently-viewed-carousel .swiper-wrapper').not('.recently-viewed-carousel-mobile').append(`       <div class="swiper-slide recently-viewed-carousel__item" data-scounter="${counter}" data-color="${response[i].variants[0].color}" data-swatchids="${swatchesIds}">
                    <a id="upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" class="product-image image-4-5 upsell-toggle">
                      ${customTag}
                      <img src="${product.images[1].url}&width=600" alt="" />
                    </a>
                    <div class="short-desc plp-product__details">
                      <h3 class="plp-product__title"><a href="#" class="upsell-toggle" id="upsell-${product.product_id}">${product.title}</a></h3>
                      <div class="plp-product__price ${classCompare}">
                        ${priceToDisplay}
                      </div>
                    </div>
                  </div>`);

                  $('.recently-viewed-carousel-mobile.swiper-wrapper').append(`       <div class="swiper-slide recently-viewed-carousel__item" data-scounter="${counter}" data-color="${response[i].variants[0].color}" data-swatchids="${swatchesIds}">
                    <a href="/products/${product.handle}" id="upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" class="product-image image-4-5">
                      ${customTag}
                      <img src="${product.images[1].url}&width=600" alt="" />
                    </a>
                    <div class="short-desc plp-product__details">
                      <h3 class="plp-product__title"><a href="#" class="upsell-toggle" id="upsell-${product.product_id}">${product.title}</a></h3>
                      <div class="plp-product__price ${classCompare}">
                        ${priceToDisplay}
                      </div>
                    </div>
                  </div>`);

                  var addToBag = 'Add To Bag';
                  if(product.sold_out) {
                    addToBag = 'Notify Me';
                  }

                  var nonUSProduct = '';
                  var nonUSProductTpl = '';
                  if(product.tags.indexOf('dev-non-us-oos') > -1) {
                    if(Shopify.country !== 'US') {
                      nonUSProduct = ' style="display: none !important;"';

                      var customLink = '';
                      var customName = '';
                      for(const i in product.metafields) {
                        if(product.metafields[i]['non_us_oos_label'] !== undefined) {
                          priceToDisplay = product.metafields[i]['non_us_oos_label']
                        }
                        if(product.metafields[i]['non_us_oos_button_link'] !== undefined) {
                          customLink = product.metafields[i]['non_us_oos_button_link']
                        }
                        if(product.metafields[i]['non_us_oos_button_name'] !== undefined) {
                          customName = product.metafields[i]['non_us_oos_button_name']
                        }
                      }

                      nonUSProductTpl = `          <div class="upsell-form">
                        <div class="atc-box">
                          <a href="${customLink}" class="btn btn--dark btn--bag btn-upsell-add btn-upsell-add--stl">${customName}</a>
                          <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn" target="_blank" rel="noopener noreferrer">FULL DETAILS</a>
                        </div>
                      </div>` 
                    }
                  }

                  $('.cart-upsell-container').append(`<div class="cart-upsell" data-productid="${product.product_id}" data-limited="${productLimited}" data-limit-val="${productQuantityLimitNumber}" data-variantid="${product.variants[0].id}" id="popup-upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-swatchids="${swatchesIds}">
                    <button class="close-upsell d-none" aria-label="Close product details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 15L15 1M1 1L15 15" stroke="#181818" stroke-width="2" aria-hidden="true"/>
                    </svg></button>
                    <div class="upsell-carousel">
                      <div class="swiper-wrapper">
                        ${images}
                      </div>
                    </div>

                    <div class="upsell-content product">
                      <h2 class="product__title">${product.title}</h2>
                      <div class="product__price  ${classCompare}" data-price="${response[i].local_price.price}">${priceToDisplay}</div>
                      <div class="product__variants product__variants--colors d-none d-lg-block" ${nonUSProduct}>
                        <div class="product-variants-title d-none d-lg-block">
                          Color: ${colorName}
                        </div>
                        <div class="swatch-colors swiper-container">
                          <div class="swiper-wrapper">
                            ${swatches}
                          </div>
                        </div>
                        <div id="swatch-colors-next" class="swiper-btn-next"></div>
                        <div id="swatch-colors-prev" class="swiper-btn-prev"></div>
                      </div>

                      <form class="upsell-form" ${nonUSProduct}>
                        <div class="random-div d-flex justify-content-between d-lg-block">
                          <div class="product__variants--colors d-lg-none">
                            <div class="custom-select-wrapper">
                              <select class="custom-select">
                                ${swatchesMobile}
                              </select>
                            </div>
                          </div>

                          <div class="swatch-size swatch-size3 custom-select-wrapper ${showSelectOptions} d-lg-none">
                            <select class="custom-select" disabled>
                              <option val="">One Size</option>
                            </select>
                          </div>

                          <div class="swatch-size swatch-size4 custom-select-wrapper ${jewelryClass} ${showAddToCart}" id="sizes-${product.product_id}">
                              ${sizes}
                          </div>
                        </div>
                        <div class="atc-box">
                          <button name="add" id="select-options" type="button" class="select-options btn btn--dark btn--bag ${showSelectOptions} d-lg-none">Select Options</button>
                          <button name="add" id="add-submit" type="submit" class="btn btn--dark btn--bag ${showAddToCart} btn-upsell-add">${addToBag}</button>
                          <div class="notify">
                              <h4 class="notify__txt">Notify me when this product is in stock </h4>
                              <div class="form-group" style="margin-bottom: 8px; margin-top: 13px;">
                                <input type="email" id="notify_email" placeholder="Enter your email" name="EMAIL" class="notifyme-control form-control form-control--border" required>
                              </div>
                              <input type="button" id="notify" class="btn btn--dark" value="Submit" />
                              <p class="notify-success-message btn btn--light" style="display: none;">you're on the list</p>

                              <div class="bis-newsletter-signup">
                                <input type="checkbox" checked id="bis-newsletter" name="bis-newsletter" class="bis-custom-checkbox">
                                <label for="bis-newsletter"><span class="bn-out"><span class="bn-in"></span></span><span class="bn-txt">Sign me up for the mailing list</span></label>
                                <div class="global-privacy-notice-element-small">By providing your email address, you agree to our <a href="${privacyPolicyFileLink}" target="blank">Privacy Policy</a>.</div>
                              </div>
                          </div>
                          <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn">FULL DETAILS</a>
                        </div>
                      </form>

                      ${nonUSProductTpl}
                    </div>
                  </div>`);

                  counter++;
                  // }
                }
              }
            }
          }

          if(counter == 1) {
            $('.section-cart').addClass('no-recently-viewed');
          }

          if($('.upsell-carousel').length) {

          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          // if(isSafari || getOS() == 'Mac OS') {

          if(window.innerWidth > 1024) {
            var height = window.innerHeight;
            var imgHeight = height - 340;
            var width = Math.floor((4 * imgHeight) / 5);
            $('.upsell-carousel, .cart-upsell').width(width);
            if(width > 493) {
              $('.upsell-carousel img').width('100%');
            } else {
              $('.upsell-carousel img').width('');
            }
          } else {
            $('.upsell-carousel, .cart-upsell').width('');
          }

            var upsellCarousel = new Swiper('.upsell-carousel', {
              spaceBetween: 7,
              slidesPerView: 'auto',
              breakpoints: {
                1025: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  watchOverflow: true,
                }
              },
              on: {
                slideChange: function () {
                  var newIndex = this.activeIndex;
                  if (typeof gtag === 'function') {
                    var sku = $('.cart-upsell-collapse').data('productid');
                    if(window.location.href.indexOf('/products/') > -1) {
                      var type = $('#producttype').val();
                      var color = $('#upsell-'+sku).parent().data('color');
                      gtag('event', `PDP_Recently Viewed_Quickview_Image Swipe_${newIndex + 1}_${type}_${sku}_${color}`);
                    } else {
                      gtag('event', `Cart_Quickview_Image Swipe_${newIndex + 1}_${sku}`);
                    }
                  }
                }
              }
            });
          }
          if($('.recently-viewed-carousel .swiper-slide').length > 1) {
            if($('.recently-viewed-carousel').length) {
              var upsellCarousel = new Swiper('.recently-viewed-carousel', {
                spaceBetween: 7,
                slidesPerView: 'auto',
                breakpoints: {
                  1025: {
                    spaceBetween: 14,
                  }
                }
              });
            }
          }

                if($('.swatch-colors').length > 0) {
                  var productCarouselColors = new Swiper('.swatch-colors', {
                    // spaceBetween: 1,
                    slidesPerView: 'auto',
                    navigation: {
                      nextEl: '#swatch-colors-next',
                      prevEl: '#swatch-colors-prev',
                    },
                  });
                }

          var selectSize = $('.cart-upsell-container .swatch-size .custom-select');
          selectSize.each(function() {
            // if($.length) {
              var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
              $(this).select2({
                placeholder: 'Select Size',
                minimumResultsForSearch: -1,
                dropdownParent: $dropdownParent1,
                dropdownCssClass: "custom-select-dropdown",
                templateResult: function(data, container) {
                  // if(data.element) {
                  //   $(container).addClass($(data.element).attr('class'));
                  // }

                  var tpl = '<span>'+data.text+'</span>';
                  var notifyMe = $(data.element).hasClass('disabled-el');
                  const delayFlag = $(data.element).data('ship-delay');
                  const shipDelayMessage = $(data.element).data('ship-delay-message');
                  const hasDelayMessage = (delayFlag === true || delayFlag === 'true') && shipDelayMessage;
                  if(notifyMe) {
                    tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                  } else if(hasDelayMessage) {
                    tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+shipDelayMessage+'</span></span>';
                  }
                  return $(tpl);
                }
              }).on('select2:select', function(e) {
                var selectedSize = e.params.data.text;

                if (typeof gtag === 'function') {
                  var sku = $('.cart-upsell-collapse').data('productid');
                  // gtag('event', `Cart_Quickview_Select Size_${selectedSize}_${sku}`);
                }
              });
            // }
          })

          $('.cart-upsell-container').on('click', '.select-options', function() {
            $(this).closest('.upsell-form').find('.chain-selector').show().removeClass('d-none');
            $(this).hide().removeClass('d-block');
            $(this).next().show().removeClass('d-none');
            return false;
          });

    $('.cart-upsell-container').on('change', 'select.chain-select', function() {


      var chainPrice = parseFloat($(this).find(':selected').data('original-price'));
      var pendantPrice = parseFloat($(this).closest('.cart-upsell').find('.product__price').data('price'));


      var totalPendantPrice = chainPrice + pendantPrice;
      // TODO should be local_price
      totalPendantPrice = formatPrice(totalPendantPrice, globalCurrency)
     $(this).closest('.cart-upsell').find('.product__price').text(totalPendantPrice);

     chainId =  $(this).find(':selected').data('prodid');

    });

          $('.swatch-size select, .swatch-size-2 select').on('change', function() {
            $('.select-error').removeClass('select-error');
            $('.size-error').hide();
            $('#show-bis').hide();
            if($(this).find(':selected').hasClass('disabled-el')) {
              $('.btn-upsell-add').hide();
              $('.notify').show();
              BISHandler();
            } else {
              $('.btn-upsell-add').show();
              $('.notify').hide();
            }

            var variantName = $(this).find(':selected').val();
            // START: scroll to selected variant image
            // var isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)').matches;
            // var imageToScroll = undefined;
            // var imageIndexToScroll = undefined;
            // $('.product__container .product__image-item img').each((index,element) => {
            //   if(variantName.includes(element.alt)) {
            //     imageToScroll = element;
            //     imageIndexToScroll = index;
            //   }
            // });

            // if(imageToScroll) {
            //   if(isMobile) {
            //     if(imageIndexToScroll > -1 && productCarousel) {
            //       productCarousel?.forEach((_c) => {
            //         if(_c.size) _c.slideTo(imageIndexToScroll);
            //       });
            //     }
            //   } else {
            //     $('html, body').animate({ scrollTop: imageToScroll.getBoundingClientRect().top + document.documentElement.scrollTop - 80}, 1000);
            //   }
            // }
            // END: scroll to selected variant image

            // if(!$(this).find(':selected').data('soldout')) {
            //   console.log('1.2')
            //   $('.product__price.money').text('SOLD OUT');

            //   console.log('>>> ', $(this).find(':selected').data('price'), $('#pendant-price').data('price'));
            //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
            //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
            //     var pendantPr = parseFloat($('#pendant-price').data('price'));
            //     $('.product__price.money').text(chainPr + pendantPr);
            //   } else {
            //     var priceDetails = {
            //       "Price": parseFloat($(this).find(':selected').data('price')),
            //       "Quantity": 1
            //     };

            //     var curEl = $(this);
            //   }
            // } else {
            //   console.log('1.3')
            //   //$('.product__price.money').text($(this).find(':selected').data('price'))
            //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
            //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
            //     var pendantPr = parseFloat($('#pendant-price').data('price'));
            //     $('.product__price.money').text(chainPr + pendantPr);
            //   } else {
            //     var priceDetails = {
            //       "Price": $(this).find(':selected').data('price'),
            //       "Quantity": 1
            //     };

            //     var curEl = $(this);
            //   }
            // }
          });

          // copied from other scripts, to be removed
   // $('.product__variants--colors .custom-select').select2({
   //    placeholder: 'Select Color',
   //    minimumResultsForSearch: -1,
   //    dropdownCssClass: "custom-select-dropdown",
   //    templateResult: function(data, container) {
   //      var img = $(data.element).attr('data-img');
   //      var handle = $(data.element).attr('data-handle');
   //      var tpl = '<a href="'+handle+'"><img src="'+img+'" />'+data.text+'</a>';
   //      return $(tpl);
   //    }
   //  });

          var selectColor = $('.cart-upsell-container .product__variants--colors .custom-select');
          console.log(selectColor, 'color swatcher select2 1')
          selectColor.each(function() {
            // if(selectColor.length) {
              var $dropdownParent2 = $(this).closest('.custom-select-wrapper');
              $(this).select2({
                placeholder: 'Select Color',
                minimumResultsForSearch: -1,
                dropdownParent: $dropdownParent2,
                dropdownCssClass: "custom-select-dropdown",
                templateResult: function(data, container) {
                  var img = $(data.element).attr('data-img');
                  var handle = $(data.element).attr('data-handle');
                  var tpl = '<span><img src="'+img+'" />'+data.text+'</span>';
                  console.log(img, handle, tpl);
                  return $(tpl);
                },
                templateSelection: function(option) {
                  var swatchid = $(option.element).data('swatchid');
                  var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                  var handle = $(option.element).attr('data-handle');
                  var tpl = '<span><img src="'+img+'" />'+option.text+'</span>';
                  console.log(img, handle, tpl);
                  return $(tpl);
                }
              });
            // }
          });

           $('.cart-upsell-container').on('change', '.product__variants--colors select', function() {
            var id = $(this).find(':selected').attr('data-swatchid');
            // console.log('upsell mobile select', id, $(this).find('.swatch-colors a[data-swatch-id='+id+']'))
            $(this).closest('.cart-upsell').find('.swatch-colors a[data-swatchid='+id+']').trigger('click');
           });

          $('.recently-viewed-carousel, .cart-upsell-container, .xyou-may-also-like-products').on('click', '.upsell-toggle, .xymal-toggle', function() {

            var target = $(this).attr('id');
            var productId = target.split('-')[1];

            if(target.indexOf('upsell') < 0) {
              target = 'upsell-'+target;
            }

            if (typeof gtag === 'function') {
              if($(this).data('swatchid')) {
                // changing color
                var colorName = $(`.product__variants--colors option[data-swatchid="${$(this).data('swatchid')}"]`).first().text();
                var productId = $('.cart-upsell-collapse').data('productid');
      var prefix = 'US';
      if(window.location.href.indexOf('eu.') > -1) {
        prefix = 'EU';
      }
if (typeof gtag === 'function') {
      if($('.cart-upsell.cart-upsell-collapse').hasClass('ymal-upsell')) {

        var productId = $(this).closest('.ymal-upsell').data('productid');
        var orderIndex = $('#upsellymal-'+productId).data('scounter');
        console.log('gtag 2', productId, orderIndex)

        var color = $(this).closest('.ymal-upsell').data('color');
        if(window.location.href.indexOf('/products/') > -1) { // todo recommend ui
          var type = $('#producttype').val();
          gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Color:${colorName}_${type}_${productId}`); // last should be color
        } else {
          gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Color:${colorName}_${productId}`); // last should be color
        }
      } else {
        if(window.location.href.indexOf('/products/') > -1) {
          //gtag('event', `Cart_Quickview_${colorName}_${productId}`);
          var type = $('#producttype').val();
          gtag('event', `PDP_Recently Viewed_Quickview_${colorName}_${type}_${productId}`);
        } else {
          gtag('event', `Cart_Quickview_${colorName}_${productId}`);
        }
      }
}

              } else {
                // clicking recommendated product
                var clickedIndex = $(this).closest('.swiper-wrapper')
                  .find('.recently-viewed-carousel__item')
                  .index($(this).parents('.recently-viewed-carousel__item'));
                  console.log('gaev 2')
        var prefix = 'US';
        if(window.location.href.indexOf('eu.') > -1) {
          prefix = 'EU';
        }
if (typeof gtag === 'function') {
                  if($(this).hasClass('ymal-toggle')) {
                    var orderIndex = $(this).data('scounter');
                    var color = $(this).data('color');
                    if(window.location.href.indexOf('/products/') > -1) { // todo recommend ui
                      var type = $('#producttype').val();
                      gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Open_${type}_${orderIndex}_${productId}_${color}`); // last should be color
                    } else {
                      gtag('event', `Cart_You May Also Like_${window.algoliaModelProper}_Quickview_Open_${orderIndex}_${productId}_${color}`); // last should be color
                    }
                  } else {
                    var orderIndex = $(this).parent().data('scounter');
                    var color = $(this).parent().data('color');
                    // var color = $(this).closest('.ymal-upsell').data('color');
                      var type = $('#producttype').val();
                    if(window.location.href.indexOf('/products/') > -1) {
                      gtag('event', `PDP_Recently Viewed_Quickview_Open_${orderIndex}_${type}_${productId}_${color}`);
                    } else {
                      gtag('event', `Cart_Product Recommendation_${clickedIndex + 1}_${productId}`);
                    }
                  }
}
              }
            }

            // console.log('>>> target',  target)
            console.log('yaml remove 1')
            $('.cart-upsell-collapse').removeClass('cart-upsell-collapse')
            $('#popup-'+target).addClass('cart-upsell-collapse');
            $('.cart-upsell-container').addClass('cart-upsell-container--visible');
            $('.cart-upsell-overlay').addClass('cart-upsell-overlay--visible');
            $('body').addClass('cart-upsell--visible');
            var swatches = $(this).closest('.recently-viewed-carousel__item').data('swatchids');
            if($(this).hasClass('ymal-toggle')) {
              swatches = $(this).data('swatchids');
            }
            if(swatches === undefined) {
              swatches = $(this).closest('.cart-upsell').data('swatchids');
            }
            console.log('product_info x4', swatches, swatches.split(',').map(Number))

            //if(swatches.split(',').map(Number) != 0) {
            if(true) {
            var dataToSend = {
              'store_name': store,
              'product_ids': swatches.split(',').map(Number),
              'iso_code': Shopify.country,
              // 'location_ids': [35407921289, 68178706569]
            }

            if(window.location.host.indexOf('eu') > -1) {
              var locationId = 50003247253;
              if($('body').attr('data-country') == 'GB') {
                locationId = 74146152597;
              }

              var dataToSend = {
                'store_name': store,
                'product_ids': swatches.split(',').map(Number),
                'iso_code': Shopify.country,
                'location_ids': [locationId]
              }
            }

console.log('product_info 4', '>',swatches.split(',').map(Number), '>',swatches != '', '>',swatches.split(',').length)

            if(swatches != '') {

            $.ajax({
              url: 'https://ald-filter-staging.herokuapp.com/api/product_info',
              type: 'POST',
              data: JSON.stringify(dataToSend),
              accept: 'application/json',
              cache: false,
              dataType: 'json',
              contentType: 'application/json',
              success: function(response) {
                var prodCount = -1;
                for(var i in response) {
                  prodCount++;
                  var img = response[i].image_url;
                  var alt = '';
                  for(var j in response[i].images) {
                    if(response[i].images[j].alt == 'dev-product-image-swatch') {
                      img = response[i].images[j].url;
                      alt = response[i].images[j].alt;
                    }
                  }

                  var colors = response[i].handles[0].colors;
                  console.log('access', colors);
                  colors = colors.split(',');
                  console.log('access', colors, colors[0], i);
                  colors = colors[prodCount];
                  console.log('access', colors);

                  $('.swatch-colors__item[data-swatchid="'+response[i].product_id+'"] .product-image').append(`<img src="${img}&width=100" z alt="${colors}">`);
                  $('option[data-swatchid="'+response[i].product_id+'"]').data('img', img+'&width=100');
                  var product = response[i];
                  // TODO should be local_price
                  var price = formatPrice(response[i].local_price.price, response[i].local_price.currency);
                  // var price = formatPrice(response[i].price, 'USD');

                  var compareAtPrice = price;

                  if(response[i].local_price.compare_at_price !== null) {
                    compareAtPrice = response[i].local_price.compare_at_price;
                  } else {
                    compareAtPrice = 0;
                  }
                  var priceToDisplay = '';
                  var classCompare = '';

                  priceToDisplay += '<span class="money">'+price+'</span>';
                  if(response[i].local_price.price < compareAtPrice && response[i].local_price.compare_at_price != 0) {
                    compareAtPrice = formatPrice(response[i].local_price.compare_at_price, response[i].local_price.currency);
                    priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                    classCompare = 'plp-product__price--compare';
                  }

                  var images = '';
                  for(var j in response[i].images) {
                    if(j != 0) {
                      if(response[i].images[j].alt != 'dev-product-image-swatch') {
                        images += `<div class="swiper-slide upsell-carousel__item">
                              <img src="${response[i].images[j].url}&width=600" alt="" />
                            </div>`
                      }
                    }
                  }
                  var sizes = '<select class="custom-select" name="sizes-'+product.product_id+'">';

                  var swatches = '';
                  var swatchesMobile = '<option value="">Select Color</option>';
                  var swatchesIds = '';
                  for(var z in response[i].handles_info) {
                    var swatchData = response[i].handles_info[z];
                    var swatchHandle = Object.keys(swatchData);
                    var swatchId = Object.values(swatchData);
                    swatchesIds += Object.values(swatchData) + ',';

                    var selected = '';
                    var selectedClass = '';
                    if(response[i].product_id == swatchId) {
                      selected = 'selected';
                      selectedClass = 'swatch-colors__item--selected';
                    }

                    swatches += `<a href="/products/${swatchHandle}" class="swiper-slide ${selectedClass} swatch-colors__item " new="" data-swatchid="${swatchId}"  data-swatchids="${swatchesIds}">
                              <div class="image-square product-image">
                              </div>
                            </a>`

                    var colors = response[i].handles[0];
                    colors = Object.values(colors);
                    colors = colors[0];

                    if(typeof colors === 'string') {
                      colors = colors.replace(/\([^)]*\)/g, '').split(',').map(function(entry) {
                        return entry.trim();
                      }).filter(function(entry) {
                        return entry !== '';
                      });
                    }

                    colors = colors[z];
                    swatchesMobile += `<option ${selected} data-img="" data-handle="" data-swatchid="${swatchId}">${colors}</option>`
                  }

                  if(response[i].handles_info == null) {
                    swatchesMobile = `<option selected data-img="${response[i].image_url}&width=100" data-handle="" data-swatchid="">${response[i].variants[0].color}</option>`;
                  }
console.log('product_info 4 1')
                  // console.log('4')
                  swatchesIds = swatchesIds.slice(0, -1);

/*

*/
console.log('product_info 4 2')
                  const shipDelaySku = response[i].metafields?.find(mf => mf.ship_delay_skus)?.ship_delay_skus || '';
                  const shipDelayMessage = response[i].metafields?.find(mf => mf.ship_delay_message)?.ship_delay_message || '';

                  if(response[i].variants.length == 1) {
                    sizes += '<option value=""></option>';
                    const singleHasDelay = shipDelaySku.indexOf(response[i].variants[0].sku) > -1 && !response[i].variants[0].sold_out;
                    const singleDelayAttr = ` data-ship-delay="${singleHasDelay}" data-ship-delay-message="${shipDelayMessage}"`;
                    if(response[i].variants[0].sold_out) {
                      sizes += `<option class="disabled-el" data-soldout="${response[i].variants[0].sold_out}"${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                    } else {
                      sizes += `<option data-soldout="${response[i].variants[0].sold_out}" selected${singleDelayAttr} value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                    }
                  } else {
                    for(var k in response[i].variants) {
                      sizes += '<option value=""></option>';
                      const variantHasDelay = shipDelaySku.indexOf(response[i].variants[k].sku) > -1 && !response[i].variants[k].sold_out;
                      const delayAttr = ` data-ship-delay="${variantHasDelay}" data-ship-delay-message="${shipDelayMessage}"`;
                      if(response[i].variants[k].sold_out) {
                        sizes += `<option class="disabled-el" data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                      } else {
                        sizes += `<option data-soldout="${response[i].variants[k].sold_out}"${delayAttr} value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                      }
                    }
                  }
                  sizes += '</select>';
console.log('product_info 4 3')
                  // if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                  //   sizes = $('.chain-select')[0].outerHTML;

                  //   swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                  //   swatchesMobile = $('.pendant-select')[0].innerHTML;
                  // }
console.log('product_info 4 4')
                  var sizesMobile = '';
                  var showSelectOptions = 'd-none';
                  var showAddToCart = '';
                  var jewelryClass = '';
                  if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                    jewelryClass = 'chain-selector';
                    showSelectOptions = 'd-block';
                    showAddToCart = 'd-none d-lg-block';
                    sizes = $('.chain-select')[0].outerHTML;
                    // sizes = '<select class="custom-select" disabled><option>One Size</option></select>'

                    swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                    swatchesMobile = $('.pendant-select')[0].innerHTML;
                  }

                  var colorName = response[i].variants[0].color;
                  var customTag = '';

                  if(response[i].tags.indexOf('PREORDER_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">Reserve</div>';
                  }
                  if(response[i].tags.indexOf('NEW_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">NEW</div>  ';
                  }
                  if(response[i].tags.indexOf('dev-product-type-women') > -1) {
                    customTag = '<div class="plp-product__tag plp-product__tag--nocaps">Women\'s</div>  ';
                  }

                  var productLimited = false;
                  var productQuantityLimitNumber = 0;
                  if(response[i].tags.indexOf('dev-qty-limit') > -1) {
                    productLimited = true;
                    productQuantityLimitNumber = response[i].tags.substring(response[i].tags.indexOf('dev-qty-limit')+14, response[i].tags.indexOf('dev-qty-limit')+15);
                  }
console.log('product_info 4 6')
                  if(!$('#popup-upsell-'+product.product_id).length) {

                    var addToBag = 'Add To Bag';
                    if(product.sold_out) {
                      addToBag = 'Notify Me';
                    }

                    var nonUSProduct = '';
                    var nonUSProductTpl = '';
                    if(product.tags.indexOf('dev-non-us-oos') > -1) {
                      if(Shopify.country !== 'US') {
                        nonUSProduct = ' style="display: none !important;"';

                        var customLink = '';
                        var customName = '';
                        for(const i in product.metafields) {
                          if(product.metafields[i]['non_us_oos_label'] !== undefined) {
                            priceToDisplay = product.metafields[i]['non_us_oos_label']
                          }
                          if(product.metafields[i]['non_us_oos_button_link'] !== undefined) {
                            customLink = product.metafields[i]['non_us_oos_button_link']
                          }
                          if(product.metafields[i]['non_us_oos_button_name'] !== undefined) {
                            customName = product.metafields[i]['non_us_oos_button_name']
                          }
                        }

                        nonUSProductTpl = `          <div class="upsell-form">
                          <div class="atc-box">
                            <a href="${customLink}" class="btn btn--dark btn--bag btn-upsell-add btn-upsell-add--stl">${customName}</a>
                            <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn" target="_blank" rel="noopener noreferrer">FULL DETAILS</a>
                          </div>
                        </div>` 
                      }
                    }

                    $('.cart-upsell-container').append(`<div class="cart-upsell" data-productid="${product.product_id}" data-limited="${productLimited}" data-limit-val="${productQuantityLimitNumber}" data-variantid="${product.variants[0].id}" id="popup-upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-swatchids="${swatchesIds}">
                      <button class="close-upsell d-none" aria-label="Close product details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 15L15 1M1 1L15 15" stroke="#181818" stroke-width="2" aria-hidden="true"/>
                      </svg></button>
                      <div class="upsell-carousel">
                        <div class="swiper-wrapper">
                          ${images}
                        </div>
                      </div>

                      <div class="upsell-content product">
                        <h2 class="product__title">${product.title}</h2>
                        <div class="product__price  ${classCompare}" data-price="${response[i].local_price.price}">${priceToDisplay}</div>
                        <div class="product__variants product__variants--colors d-none d-lg-block" ${nonUSProduct}>
                          <div class="product-variants-title d-none d-lg-block">
                            Color: ${colorName}
                          </div>
                          <div class="swatch-colors swiper-container">
                            <div class="swiper-wrapper">
                              ${swatches}
                            </div>
                          </div>
                          <div id="swatch-colors-next" class="swiper-btn-next"></div>
                          <div id="swatch-colors-prev" class="swiper-btn-prev"></div>
                        </div>

                      <form class="upsell-form" ${nonUSProduct}>
                        <div class="random-div d-flex justify-content-between d-lg-block">
                          <div class="product__variants--colors d-lg-none">
                            <div class="custom-select-wrapper">
                              <select class="custom-select">
                                ${swatchesMobile}
                              </select>
                            </div>
                          </div>

                          <div class="swatch-size swatch-size3 custom-select-wrapper ${showSelectOptions} d-lg-none">
                            <select class="custom-select" disabled>
                              <option val="">One Size</option>
                            </select>
                          </div>

                          <div class="swatch-size swatch-size4 custom-select-wrapper ${jewelryClass} ${showAddToCart}" id="sizes-${product.product_id}">
                              ${sizes}
                          </div>
                        </div>
                        <div class="atc-box">
                          <button name="add" id="select-options" type="button" class="select-options btn btn--dark btn--bag ${showSelectOptions} d-lg-none">Select Options</button>
                          <button name="add" id="add-submit" type="submit" class="btn btn--dark btn--bag ${showAddToCart} btn-upsell-add">${addToBag}</button>
                          <div class="notify">
                              <h4 class="notify__txt">Notify me when this product is in stock </h4>
                              <div class="form-group" style="margin-bottom: 8px; margin-top: 13px;">
                                <input type="email" id="notify_email" placeholder="Enter your email" name="EMAIL" class="notifyme-control form-control form-control--border" required>
                              </div>
                              <input type="button" id="notify" class="btn btn--dark" value="Submit" />
                              <p class="notify-success-message btn btn--light" style="display: none;">you're on the list</p>

                              <div class="bis-newsletter-signup">
                                <input type="checkbox" checked id="bis-newsletter" name="bis-newsletter" class="bis-custom-checkbox">
                                <label for="bis-newsletter"><span class="bn-out"><span class="bn-in"></span></span><span class="bn-txt">Sign me up for the mailing list</span></label>
                                <div class="global-privacy-notice-element-small">By providing your email address, you agree to our <a href="${privacyPolicyFileLink}" target="blank">Privacy Policy</a>.</div>
                              </div>
                          </div>
                          <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn">FULL DETAILS</a>
                        </div>
                      </form>

                      ${nonUSProductTpl}
                      </div>
                    </div>`);
                  }
                }

          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          // if(isSafari || getOS() == 'Mac OS') {
          if(window.innerWidth > 1024) {
            var height = window.innerHeight;
            var imgHeight = height - 340;
            var width = Math.floor((4 * imgHeight) / 5);
            $('.upsell-carousel, .cart-upsell').width(width);
            if(width > 493) {
              $('.upsell-carousel img').width('100%');
            } else {
              $('.upsell-carousel img').width('');
            }
          } else {
            $('.upsell-carousel, .cart-upsell').width('');
          }

                if($('.upsell-carousel').length) {
                  var upsellCarousel = new Swiper('.upsell-carousel', {
                    spaceBetween: 7,
                    slidesPerView: 'auto',
                    breakpoints: {
                      1025: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        watchOverflow: true,
                      }
                    }
                  });
                }

                if($('.recently-viewed-carousel .swiper-slide').length > 1) {
                  if($('.recently-viewed-carousel').length) {
                    var upsellCarousel = new Swiper('.recently-viewed-carousel', {
                      spaceBetween: 7,
                      slidesPerView: 'auto',
                      breakpoints: {
                        1025: {
                          spaceBetween: 14,
                        }
                      }
                    });
                  }
                }

                if($('.swatch-colors').length > 0) {
                  var productCarouselColors = new Swiper('.swatch-colors', {
                    // spaceBetween: 1,
                    slidesPerView: 'auto',
                    navigation: {
                      nextEl: '#swatch-colors-next',
                      prevEl: '#swatch-colors-prev',
                    },
                  });
                }

                var selectSize = $('.swatch-size .custom-select');
                selectSize.each(function() {
                  // if($.length) {
                    var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
                    $(this).select2({
                      placeholder: 'Select Size',
                      minimumResultsForSearch: -1,
                      dropdownParent: $dropdownParent1,
                      dropdownCssClass: "custom-select-dropdown",
                      templateResult: function(data, container) {
                        // if(data.element) {
                        //   $(container).addClass($(data.element).attr('class'));
                        // }

                        var tpl = '<span>'+data.text+'</span>';
                        var notifyMe = $(data.element).hasClass('disabled-el');
                        const delayFlag = $(data.element).data('ship-delay');
                        const shipDelayMessage = $(data.element).data('ship-delay-message');
                        const hasDelayMessage = (delayFlag === true || delayFlag === 'true') && shipDelayMessage;
                        if(notifyMe) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                        } else if(hasDelayMessage) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">'+shipDelayMessage+'</span></span>';
                        }
                        return $(tpl);
                      }
                    });
                  // }
                })

                var selectSize2 = $('.swatch-size .chain-select');
                selectSize2.each(function() {
                  // if($.length) {
                    var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
                    $(this).select2({
                      placeholder: 'Select Size',
                      minimumResultsForSearch: -1,
                      dropdownParent: $dropdownParent1,
                      dropdownCssClass: "custom-select-dropdown",
                      templateResult: function(data, container) {

                        var tpl = '<span>'+data.text+'</span>';
                        var notifyMe = $(data.element).data('price');
                        notifyMe = notifyMe + '';
                        // notifyMe = notifyMe.replace('.00', '');
                        if(parseInt(notifyMe) != 0) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">+ '+notifyMe+'</span></span>';
                        }
                        // if(data.element) {
                        //   $(container).addClass($(data.element).attr('class'));
                        // }

                        // var tpl = '<span>'+data.text+'</span>';
                        // var notifyMe = $(data.element).hasClass('disabled-el');
                        // if(notifyMe) {
                        //   tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                        // }
                        return $(tpl);
                      }
                    });
                  // }
                })

                if($('.swatch-colors').length > 0) {
                  var productCarouselColors = new Swiper('.swatch-colors', {
                    // spaceBetween: 1,
                    slidesPerView: 'auto',
                    navigation: {
                      nextEl: '#swatch-colors-next',
                      prevEl: '#swatch-colors-prev',
                    },
                  });
                }

                $('.swatch-size select, .swatch-size-2 select').on('change', function() {
                  $('.select-error').removeClass('select-error');
                  $('.size-error').hide();
                  $('#show-bis').hide();
                  if($(this).find(':selected').hasClass('disabled-el')) {
                    $('.btn-upsell-add').hide();
                    $('.notify').show();
                  } else {
                    $('.btn-upsell-add').show();
                    $('.notify').hide();
                  }

                  BISHandler($(this).val());

                  var variantName = $(this).find(':selected').val();
                  // START: scroll to selected variant image
                  // var isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)').matches;
                  // var imageToScroll = undefined;
                  // var imageIndexToScroll = undefined;
                  // $('.product__container .product__image-item img').each((index,element) => {
                  //   if(variantName.includes(element.alt)) {
                  //     imageToScroll = element;
                  //     imageIndexToScroll = index;
                  //   }
                  // });

                  // if(imageToScroll) {
                  //   if(isMobile) {
                  //     if(imageIndexToScroll > -1 && productCarousel) {
                  //       productCarousel?.forEach((_c) => {
                  //         if(_c.size) _c.slideTo(imageIndexToScroll);
                  //       });
                  //     }
                  //   } else {
                  //     $('html, body').animate({ scrollTop: imageToScroll.getBoundingClientRect().top + document.documentElement.scrollTop - 80}, 1000);
                  //   }
                  // }
                  // END: scroll to selected variant image

                  // if(!$(this).find(':selected').data('soldout')) {
                  //   console.log('1.2')
                  //   $('.product__price.money').text('SOLD OUT');

                  //   console.log('>>> ', $(this).find(':selected').data('price'), $('#pendant-price').data('price'));
                  //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                  //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                  //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                  //     $('.product__price.money').text(chainPr + pendantPr);
                  //   } else {
                  //     var priceDetails = {
                  //       "Price": parseFloat($(this).find(':selected').data('price')),
                  //       "Quantity": 1
                  //     };

                  //     var curEl = $(this);
                  //   }
                  // } else {
                  //   console.log('1.3')
                  //   //$('.product__price.money').text($(this).find(':selected').data('price'))
                  //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                  //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                  //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                  //     $('.product__price.money').text(chainPr + pendantPr);
                  //   } else {
                  //     var priceDetails = {
                  //       "Price": $(this).find(':selected').data('price'),
                  //       "Quantity": 1
                  //     };

                  //     var curEl = $(this);
                  //   }
                  // }
                });

                var selectColor = $('.product__variants--colors .custom-select');

                selectColor.each(function() {
                  // if(selectColor.length) {
                    var $dropdownParent2 = $(this).closest('.custom-select-wrapper');
                    $(this).select2({
                      placeholder: 'Select Color',
                      minimumResultsForSearch: -1,
                      dropdownParent: $dropdownParent2,
                      dropdownCssClass: "custom-select-dropdown",
                      templateResult: function(data, container) {
                        var swatchid = $(data.element).data('swatchid');
                        var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                        var handle = $(data.element).attr('data-handle');
                        var tpl = '<span><img src="'+img+'" />'+data.text+'</span>';
                        return $(tpl);
                      },
                      templateSelection: function(option) {
                        var swatchid = $(option.element).data('swatchid');
                        var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                        var handle = $(option.element).attr('data-handle');
                        var tpl = '<span><img src="'+img+'" />'+option.text+'</span>';
                        return $(tpl);
                      }
                    });
                  // }
                });

              }
            });

            }

}

            return false
          });

          $('.cart-upsell-container').on('click', '.swatch-colors__item', function() {
            var target = $(this).data('swatchid');
            var $upsellModals = $('.cart-upsell-container .cart-upsell');
            $(this).find('.close-upsell').trigger('click');
            // $('#popup-upsell-'+id)

            // var target = $(this).attr('id');

            $upsellModals.addClass('cart-upsell--no-transition');
            console.log('yaml remove 2')
            $('.cart-upsell-collapse').removeClass('cart-upsell-collapse');
            $('#popup-upsell-'+target).addClass('cart-upsell-collapse');
            var releaseTransitions = function() {
              $upsellModals.removeClass('cart-upsell--no-transition');
            };
            setTimeout(releaseTransitions, 0);

            // setTimeout(function() {
                if($('.swatch-colors').length > 0) {
                  var productCarouselColors = new Swiper('.swatch-colors', {
                    // spaceBetween: 1,
                    slidesPerView: 'auto',
                    navigation: {
                      nextEl: '#swatch-colors-next',
                      prevEl: '#swatch-colors-prev',
                    },
                  });
                }
            // }, 2000)

            return false;
          });

          $('.btn-upsell-add').on('click', function() {
            var sku = $('.cart-upsell-collapse').data('productid');
            if (typeof gtag === 'function' && sku) {
              // gtag('event', `Cart_Quickview_Add to Bag_${sku}`);
            }
          });

          $('.upsell-full-details-btn').on('click', function() {
            var sku = $('.cart-upsell-collapse').data('productid');
            if (typeof gtag === 'function' && sku) {
              gtag('event', `Cart_Quickview_Full Details_${sku}`);
            }
          });
        }
      });
    } else {
      $('.section-cart').addClass('no-recently-viewed');
      $('.pdp-recommendations .recently-viewed').remove();
    }
      }
    }
  }

  $(function () {
    aldscripts.init();
  });

})(jQuery);

    function BISCallback(data){
      var msg = '';
      var success = true;
      // if (data.status == 'OK') {
      if (data.indexOf('was registered') > -1) {
        //msg = 'Thank you. You will be sent an email when this product is in stock again';
        //$('.bismessage').text(msg);
        $('.notify-success-message').show();
        $('.notify h4, .notify input').hide();

        $('.bis-newsletter-signup').hide();
      } else {
        // for (var k in data.errors) {
        //   msg += data.errors[k].join();
        // }
        // if(msg === 'You have already registered for a notification for that item.') {
        if(data.indexOf('already registered') > -1) {
          $('.notify__txt').addClass('atc-error').text('You have already registered for a notification.').show();
        } else {
          $('.notify__txt').addClass('atc-error').text('Please enter a valid email address').show();
        }
        $('#notify_email').addClass('atc-error');
        $('.notify__txt').addClass('bis-error');
        success = false;
        // $('.notify-success-message').text(msg).show();
        // $('.notify h4, .notify input').hide();
      }
      if(success) {
        setTimeout(function() {
          $('.notify h4').text('Notify me when this product is in stock').removeClass('atc-error');
          $('.notify h4, .notify input, #notify').show();
          $('.notify input[type="email"]').val('');
          $('.notify-success-message').hide();
          $('#add-submit').show();

          $(".swatch-size .custom-select").val('').trigger('change')
          $('#show-bis').show();
          $('.notify').hide();
          // $('#notify_email').attr('disabled', true);
          $('.swatch-size__item input:checked').prop('checked', false);

          $('#k_id_email_product').val(biseml);
          $('#email_signup_product').trigger('submit');
        }, 4000);
      }
    }

        function BISHandler(id) {

      $('.cart-upsell-container').on('click', '#notify', function(e){
        e.preventDefault();

        $notify = $('.cart-upsell-collapse');

        var variantId = $notify.find('.swatch-size select :selected').val();
        var variant_id = $notify.find('.swatch-size select :selected').val();
        var email = $notify.find('#notify_email').val();
        var productId = $(this).closest('.cart-upsell').data('productid');
        var sku = $(this).closest('.cart-upsell').data('productsku')
        var title = $(this).closest('.cart-upsell').find('.product__title').text()
        var handle = $(this).closest('.cart-upsell').find('.upsell-full-details-btn').attr('href');
        handle = handle.replace('/products/', '');
        // biseml = $notify.find('#notify_email').val();
console.log('biseml', variantId, variant_id)
        if(variantId === '') {
          //$('.size-error').show();

          $notify.find('.swatch-size').addClass('select-error');

        } else {
          if ( email == "" || email.indexOf('@') == -1 ) {
            $notify.find('.notify__txt').addClass('atc-error').text('Please enter a valid email address').show();
            $notify.find('#notify_email').addClass('atc-error');
            if($(window).width() < 1025) {
              $notify.find('#notify_email').val('enter a valid email address')
            }
          } else {
            // $('.notify__txt').css('visibility', 'hidden').hide();
            $notify.find('.notify__txt').hide();
            $notify.find('#notify_email').removeClass('atc-error');
            // BIS.createPopover(email, variantId);
            //BIS.create(email, variantId, productId);

            // submit data to backend

            var store = 'aime-leon-dore';
            if(window.location.host.indexOf('eu') > -1) {
              store = 'aime-leon-dore-eu';
            }
            if(window.location.host.indexOf('dev') > -1) {
              store = 'aime-leon-dore-dev-store';
            }
            if(window.location.host.indexOf('eu-dev') > -1) {
              store = 'aime-leon-dore-eu-dev';
            }

            var dataToSend = {
              'store': store,
              'market': Shopify.country,
              'product_id': productId,
              'variant_id': $('.cart-upsell-collapse').find('.swatch-size.swatch-size4 select :selected').val(),
              'email': email,
              'handle': handle,
              'sku': sku,
              'product_title': title,
              'store_url': window.location.origin
            }

            $.ajax({
              url: 'https://ald-filter-staging.herokuapp.com/api/bis/subscribe',
              type: 'POST',
              data: JSON.stringify(dataToSend),
              accept: 'application/json',
              cache: false,
              dataType: 'json',
              contentType: 'application/json',
              success: function(response) {
                console.log('>> new bis response', response);
                BISCallback(response);
              }
            })

        $notify.find('.notify-success-message').show();
        $notify.find('.notify h4, .notify input').hide();

        $notify.find('.bis-newsletter-signup').hide();

        setTimeout(function() {
          // $('.notify h4').text('Notify me when this product is in stock').removeClass('atc-error');
          $notify.find('.notify input, #notify').show();
          $notify.find('.notify input[type="email"]').val('');
          $notify.find('.notify-success-message').hide();
          $notify.find('#add-submit').show();

          $notify.find(".swatch-size .custom-select").val('').trigger('change')
          // $('#show-bis').show();
          $notify.find('.notify').hide();
          // $('#notify_email').attr('disabled', true);
          $notify.find('.swatch-size__item input:checked').prop('checked', false);

            $('.cart-upsell-collapse').find('.close-upsell').trigger('click');
            // $('#popup-upsell-'+id)

            // var target = $(this).attr('id');

            // $('.cart-upsell-collapse').removeClass('cart-upsell-collapse')

          // $('#k_id_email_product').val(biseml);
          // $('#email_signup_product').trigger('submit');
        }, 4000);
          }
        }

      })
    }
let os = "unknown";
function getOS() {
  const userAgent = window.navigator.userAgent;
  const platform =
    window.navigator?.userAgentData?.platform || window.navigator.platform;
  const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K", "macOS"];
  const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
  const iosPlatforms = ["iPhone", "iPad", "iPod"];

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (/Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}
